import React, { Component } from 'react';
import { apisettigs } from '../../../src/settings.js';
import './Base.css';
import Topbar from '../topbar/Topbar.js';
import Home from '../home/Home.js';
import Solicitacao from '../solicitacao/Solicitacao.js';
import Ordem from '../ordem/Ordem.js';
import Mensagens from '../mensagens/Mensagens.js';
import ListarItens from '../listarItens/ListarItens.js';
import Cotacoes from '../cotacaoes/Cotacoes.js';
import ListarSolicitacoes from '../listarSolicitacoes/ListarSolicitacoes.js';
import { Tabs } from '../tabs/Tabs.js';
import CentralMensagens from '../centralMensagens/CentralMensagens.js';
import CtrMsgMensagens from '../centralMensagens/Mensagens.js';


class Base extends Component {

    state = {
        uPhoto: null,
        tBarLoc: 'Home',
        apprPerm: '',
    };

    homeComp = React.createRef();
    solComp = React.createRef();
    ordComp = React.createRef();
    mensagens = React.createRef();
    itens = React.createRef();
    cotacoes = React.createRef();
    listarSolics = React.createRef();
    centralmensagens = React.createRef();
    ctrlMsgMensagen = React.createRef();

    
    componentDidMount(){

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };

        fetch(apisettigs.endpoints.topbar, requestOptions).then(response => response.json())
        .then(data => {
            this.setState({uPhoto: data.user_photo});
            this.homeComp.current.showHome();
        })



        const requestOptions2 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };
        
        fetch(apisettigs.endpoints.homeShowPerms, requestOptions2)
        .then(response => response.json())
        .then(data => {

            if (data.orderApprover === 'Y' && data.requestApprover === 'N'){
                this.setState({apprPerm: 'O'});
            }
            else if (data.requestApprover === 'Y' && data.orderApprover === 'N' ){
                this.setState({apprPerm: 'R'});
            }
            else if (data.orderApprover === 'Y' && data.requestApprover === 'Y'){
                this.setState({apprPerm: 'RO'});
            }
            else{
                this.setState({apprPerm: ''});
            }

        });

    }

    showHome = () => {
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.showHome();
        this.centralmensagens.current.hideCentralMensagens();
        this.setState({tBarLoc: 'Home'});
    }

    showSolicitacao = () => {
        this.solComp.current.showSolic();
        this.homeComp.current.hideHome();
        this.ordComp.current.hideOrdem();
        this.centralmensagens.current.hideCentralMensagens();
        this.setState({tBarLoc: 'Solicitação'});
    }

    showOrdem = () => {
        this.solComp.current.hideSolic();
        this.homeComp.current.hideHome();
        this.centralmensagens.current.hideCentralMensagens();
        this.ordComp.current.showOrdem();
        this.setState({tBarLoc: 'Ordem'});
    }

    showMensagens = (reqType, reqid, frmCtrlMsg) => {
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.hideHome();
        this.centralmensagens.current.hideCentralMensagens();
        this.mensagens.current.showMsgs(reqType, reqid, frmCtrlMsg);
    }

    showListarItens = (reqType, reqid) => {
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.hideHome();
        this.itens.current.showListarItens(reqType, reqid);

    }

    showCotacoesP = (reqid) => {
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.hideHome();
        this.cotacoes.current.showCotacoes(reqid);
    }

    showListarSolicitacoes = (reqid) => {
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.hideHome();
        this.listarSolics.current.showListarSolicitacoes(reqid);
    }

    showCentralMsg = () => {
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.hideHome();
        this.centralmensagens.current.showCentralMensagens();
        this.setState({tBarLoc: 'Mensagens'});
    }

    showCtrlMsgMensagen = (msgid, read, asnwd, msgdt, rqtyp, rqid) =>{
        this.solComp.current.hideSolic();
        this.ordComp.current.hideOrdem();
        this.homeComp.current.hideHome();
        this.centralmensagens.current.hideCentralMensagens();
        this.ctrlMsgMensagen.current.showCtrMsgMensagen(msgid, read, asnwd, msgdt, rqtyp, rqid);
    }

    hideSubMenus = () => {
        this.mensagens.current.hideMsgs();
        this.itens.current.hideListarItens();
        this.cotacoes.current.hideCotacoes();
        this.listarSolics.current.hideListarSolicitacoes();
        this.ctrlMsgMensagen.current.hideCtrMsgMensagen();
    }


    render(){
        if (this.state.uPhoto !== null){
            return (
                <>  
                    <div className='container-fluid baseCont ' id="bcnt" >
                        <Topbar location={this.state.tBarLoc} uPhoto={this.state.uPhoto} />
                        
                        <div className='container mt-3  ' style={{'padding':'0', }}>
                            <div className='d-flex justify-content-center'>
                            <nav>
                                <ul className="Tabs">
                                    <Tabs apprPerm={this.state.apprPerm} showHome={this.showHome} showSol={this.showSolicitacao} showOrd={this.showOrdem} showCentralMsg={this.showCentralMsg} hideSubMenus={this.hideSubMenus} />
                                </ul>
                            </nav>
                            </div>
                        </div>
                        
                        <Home ref={this.homeComp} showSolic = {this.showSolicitacao} showOrd = {this.showOrdem} showCentralMsg={this.showCentralMsg} />
                        <Solicitacao ref={this.solComp} showMensagens={this.showMensagens} showListarItens={this.showListarItens} />
                        <Ordem ref={this.ordComp} showMensagens={this.showMensagens} showListarItens={this.showListarItens} showCotacoes={this.showCotacoesP} showListarSolics={this.showListarSolicitacoes}/>
                        <Mensagens ref={this.mensagens} showSolic={this.showSolicitacao} showOrd={this.showOrdem} />
                        <ListarItens ref={this.itens} showSolic={this.showSolicitacao} showOrd={this.showOrdem}/>
                        <Cotacoes ref={this.cotacoes} showOrd={this.showOrdem}/>
                        <ListarSolicitacoes ref={this.listarSolics} showOrd={this.showOrdem}/>
                        <CentralMensagens ref={this.centralmensagens} showCtrlMsgMensagen={this.showCtrlMsgMensagen} />
                        <CtrMsgMensagens ref={this.ctrlMsgMensagen}  showCentralMsg={this.showCentralMsg}  />
                   </div>

                   
                </>
            );
        }
        else{
            return('loading...');
        }

    }
    
}

export default Base;